/**
 * Implementuje třídá podporující šifrování dat po blocích
 */
export interface IStreamEncryptor {
    /**
     * Velikost šifrovacího bloku
     */
    readonly blockSize: number;

    /**
     * Vypočítá, jak budou velká data po jejich zašifrování
     * @param originalSize Velikost původních dat
     */
    getEncryptedSize(originalSize: number): number;

    /**
     * Šifruje data po blocích.
     * @param data Blok dat, který se má zašifrovat.
     * @param lastBlock Určuje jestli v datech je poslední block, která se bude šifrovat.
     */
    encryptBlock(data: BufferSource | undefined | null, lastBlock?: boolean): Promise<ArrayBuffer>;
}
